export default [
  {
    header: 'Обратная связь',
    resource: 'feedback',
    action: 'view',
  },
  {
    title: 'Статистика отзывов',
    route: 'feedback-stats',
    icon: 'MessageSquareIcon',
    resource: 'feedback',
    action: 'view',
  },
]
